import locationService from './service'
export default {
  getAllLocations ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      locationService.getAll()
        .then(({data}) => {
          if (data.code === 200) {
            commit('SET_ALL_LOCATIONS', data)
            resolve()
          }
        })
        .catch((err) => {
          console.log(err)
          reject()
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/location/store/actions.js